module.exports = __webpack_public_path__ + "static/media/is.357dcb1c.svg";